function getMessage(messages, key) {
  return key.split(".").reduce((value, part) => value?.[part], messages);
}

function interpolate(message, parameters) {
  return message.replace(/\{([a-zA-Z0-9_]+)\}/g, (placeholder, key) =>
    Object.prototype.hasOwnProperty.call(parameters, key)
      ? String(parameters[key])
      : placeholder,
  );
}

export function createTranslator({
  locale,
  currency = "EUR",
  messages,
  fallbackMessages = {},
}) {
  if (!messages || typeof messages !== "object" || Array.isArray(messages)) {
    throw new Error("Translations must be an object");
  }

  function t(key, parameters = {}) {
    const message = getMessage(messages, key) ?? getMessage(fallbackMessages, key);
    return typeof message === "string" ? interpolate(message, parameters) : key;
  }

  function formatCurrency(value) {
    const amount = Number(value);
    if (!Number.isFinite(amount)) {
      throw new Error(`Invalid currency value: ${value}`);
    }
    return new Intl.NumberFormat(locale, {
      style: "currency",
      currency,
    }).format(amount);
  }

  function formatDate(value, options = { dateStyle: "long" }) {
    const date = value instanceof Date ? value : new Date(value);
    if (Number.isNaN(date.getTime())) {
      throw new Error(`Invalid date value: ${value}`);
    }
    return new Intl.DateTimeFormat(locale, options).format(date);
  }

  return Object.freeze({ t, formatCurrency, formatDate });
}
